module.exports = __webpack_public_path__ + "static/media/YF06_4.634308a9.jpg";